import { render, staticRenderFns } from "./batch-extension-record-list.vue?vue&type=template&id=11944744"
import script from "./batch-extension-record-list.vue?vue&type=script&lang=js"
export * from "./batch-extension-record-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports